(() => {
  const SUBMITTING_CLASS = 'contact-form__form--submitting';
  const SUBMITTING_LABEL = '送信中...';

  // 送信ボタンの連打による多重送信を防ぐ。
  // click ではなく submit を捕捉することで、required の検証に
  // 失敗した場合はボタンが無効化されないようにしている。
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.classList.contains('contact-form__form')) return;

      if (form.classList.contains(SUBMITTING_CLASS)) {
        event.preventDefault();
        return;
      }

      form.classList.add(SUBMITTING_CLASS);

      // 送信そのものを妨げないよう、POST が始まった後に無効化する。
      setTimeout(() => {
        form.querySelectorAll('button[type="submit"]').forEach((button) => {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');

          // ラベルはテーマ設定由来なので、復帰用に元の文言を退避しておく。
          button.dataset.originalLabel = button.textContent.trim();
          button.textContent = SUBMITTING_LABEL;
        });
      }, 0);
    },
    true
  );

  // 戻るボタンで bfcache から復元されたときに、
  // 無効化されたままのフォームが残らないようにする。
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;

    document.querySelectorAll(`.${SUBMITTING_CLASS}`).forEach((form) => {
      form.classList.remove(SUBMITTING_CLASS);
      form.querySelectorAll('button[type="submit"]').forEach((button) => {
        button.disabled = false;
        button.removeAttribute('aria-disabled');

        if (button.dataset.originalLabel) {
          button.textContent = button.dataset.originalLabel;
          delete button.dataset.originalLabel;
        }
      });
    });
  });
})();
